import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    *, *::before, *::after {
        margin: 0;
        box-sizing: border-box
    }

    [class*="col-md-"] {
        margin-bottom: var(--bs-border-radius-lg);
        margin-top: var(--bs-border-radius-lg);
    }

    .input-group-text{
        background: ${({theme}) => theme.bg2};
        color: ${({theme}) => theme.text}!important;
    }

    [id*="react-select"]{
        color: ${({theme}) => theme.select}!important;
    }

    body {
        background: ${({theme}) => theme.bg2};
        color: ${({theme}) => theme.text}!important;
        font-family: 'Roboto', sans-serif;
        letter-spacing: .6px;
    }

    .modal-content {
        background: ${({theme}) => theme.bg2}!important;;
        color: ${({theme}) => theme.text}!important;
        font-family: 'Roboto', sans-serif;
        letter-spacing: .6px;
    }
`;